module.exports = __webpack_public_path__ + "img/18.91f80bbd.jpg";